const transformToUpdateMenuScrapingClusterInput = ({ id, ...data }) => {
  const {
    menuScrapingTemplate,
    masterScrapingCluster,
    expectedMenuFormat,
    areWorkingHoursIrrelevant,
    isAutomaticRetryEnabled,
  } = data

  return {
    id,
    data: {
      expectedMenuFormat: expectedMenuFormat || null,
      menuScrapingTemplateId: menuScrapingTemplate?.id || null,
      masterScrapingClusterId: masterScrapingCluster?.id,
      areWorkingHoursIrrelevant: areWorkingHoursIrrelevant || false,
      isAutomaticRetryEnabled: isAutomaticRetryEnabled || false,
    },
  }
}

export default transformToUpdateMenuScrapingClusterInput
